import React from "react"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {syncOutline, syncSharp} from "ionicons/icons";
import {useTranslation} from "react-i18next";
import DataSourceSync from "@customTypes/DataSourceSync";

interface props {
    disabled?: boolean
    item: DataSourceSync
    sync: any
}

const ListItemButtonSync: React.FC<props> = ({ disabled, item, sync }) => {
    const [presentAlert]     = useIonAlert()
    const { t }              = useTranslation()

    const alertSync = async () => {
        return presentAlert({
            header: 'Handmatige synchronisatie uitvoeren?',
            subHeader: t('data-source-syncs.names.' + item.dataSourceSyncType.name + '.description'),
            message: 'Let op: deze synchronisatie kan enige tijd duren, ' +
                'en is afhankelijk van de hoeveelheid data die moet worden verwerkt.',
            buttons: [
                {
                    text:    t('common.cancel'),
                    role:    'cancel',
                    handler: () => onCancel(),
                },
                {
                    text:    t('common.synchronize'),
                    role:    'confirm',
                    handler: () => onSync(),
                }
            ],
        })
    }

    const onCancel = () => {}

    const onSync = async () => {
        await sync(item);
    }

    return (
        <IonButton
            color="medium"
            fill="clear"
            shape="round"
            disabled={disabled}
            onClick={alertSync}
        >
            <IonIcon slot="icon-only" ios={syncOutline} md={syncSharp} />
        </IonButton>
    )
}

export default ListItemButtonSync